var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallArrowBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 6.3 10.9",
    style: {
      enableBackground: "new 0 0 6.3 10.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(-28 -359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5,369.9c0.2,0,0.4-0.1,0.5-0.2c0.3-0.3,0.3-0.8,0-1.1l-4.2-4.2l4.2-4.2c0.3-0.3,0.3-0.8,0-1.1       c-0.3-0.3-0.8-0.3-1.1,0l-4.8,4.7c-0.1,0.1-0.2,0.3-0.2,0.5s0.1,0.4,0.2,0.5l4.8,4.7C33.1,369.8,33.3,369.9,33.5,369.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrowBack);
export default __webpack_public_path__ + "static/media/small-arrow-back.764643e1f4c7d30ce5560296acec1533.svg";
export { ForwardRef as ReactComponent };